import { useDispatch, useSelector } from 'react-redux';

import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import CircularProgress from '@mui/material/CircularProgress';

import {
  getRuleCommissionCollected,
  selectRuleCollectedCommission,
  selectRuleCollectedCommissionLoading,
} from '../../../store/payment-orchestration-rules.slice';

export default function CollectedCommission({ id, values, isEdit }) {
  const dispatch = useDispatch();

  const ruleCollectedCommissionLoading = useSelector(
    selectRuleCollectedCommissionLoading,
  );
  const ruleCollectedCommission = useSelector(selectRuleCollectedCommission);

  const { source, effectiveEndDate, effectiveStartDate } = values;

  const isValidForCollectedCommissionSearch =
    source &&
    effectiveEndDate &&
    effectiveStartDate &&
    !ruleCollectedCommissionLoading &&
    isEdit;

  const handleGetCollectedCommission = () => {
    dispatch(getRuleCommissionCollected(id));
  };

  return (
    <FormControl
      fullWidth
      variant="outlined">
      <InputLabel htmlFor="outlined-adornment-collected-commission">
        Collected Commission
      </InputLabel>
      <OutlinedInput
        id="outlined-adornment-collected-commission"
        type="number"
        disabled={!isEdit}
        value={ruleCollectedCommission}
        readOnly={!isValidForCollectedCommissionSearch}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleGetCollectedCommission}
              disabled={!isValidForCollectedCommissionSearch}
              edge="end">
              {ruleCollectedCommissionLoading ? (
                <CircularProgress
                  color="secondary"
                  size="25px"
                />
              ) : (
                <SearchIcon
                  color={
                    isValidForCollectedCommissionSearch
                      ? 'secondary'
                      : 'inherit'
                  }
                />
              )}
            </IconButton>
          </InputAdornment>
        }
        label="Collected Commission"
      />
      {isEdit && (
        <FormHelperText id="outlined-weight-helper-text">
          Click search to get the collected commission for the rule
        </FormHelperText>
      )}
    </FormControl>
  );
}
